import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from './common/services/api.service';
import { StorageService } from './common/services/storage.service';

declare var test: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'client';
  isModalVisible = false;
  upcomingEvents = '';
  lastUpdate = '';

  constructor(
    private cookieService: CookieService,
    private apiService: ApiService,
    private storageService: StorageService) {
  }

  ngOnInit () {
    test = this;
    this.getUpcomingEvents();
  }

  resetModal(e: any) {
    console.log('resetModal');
    const now = new Date();
    now.setTime(now.getTime() + 1 * 3600 * 1000);
    window.document.cookie = 'shownModal=true; expires=' + now.toUTCString() + ';';
  }

  getUpcomingEvents() {
    this.apiService.get('upcomingevents.asp', false).then((response: any) => {
      this.upcomingEvents = response.content || '';
      this.lastUpdate = response.lastUpdate || '';
      this.storageService.setItem('upcomingevents', this.upcomingEvents);
      this.storageService.setItem('lastUpdate', this.lastUpdate);

      // show modal if: no cookie 'shownmodal' or upcomingEvents text is not empty
      this.isModalVisible = this.upcomingEvents !== ''; // !Boolean(this.cookieService.check('shownModal') || null || this.upcomingEvents.length === 0);

    }).catch(() => {
      this.storageService.setItem('upcomingevents', '');
      this.storageService.setItem('lastUpdate', '');

      // show modal if: no cookie 'shownmodal' and upcomingEvents text is not empty
      this.isModalVisible = !Boolean(this.cookieService.check('shownModal') || null || this.upcomingEvents.length === 0);
    });
  }
}
